import {useQuery} from "@tanstack/react-query";
import {PostExternalProductReadUserBeforeOrderListApiForm} from "../interface";
import { postExternalProductReadUserBeforeOrderListApi } from "../../../../../api/product/ProductExApi";

type Props = {
    param: PostExternalProductReadUserBeforeOrderListApiForm;
};

export const usePostExternalProductReadUserBeforeOrderList = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["postExternalProductReadUserBeforeOrderList", param],
        queryFn: async () => await postExternalProductReadUserBeforeOrderListApi(param),
        select: (res) => res?.data?.result ?? []
    });
    return {data};
};
